import { NumberField as BaseNumberField } from '#client/components/ui/NumberField';

interface NumberFieldProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number | undefined;
  max?: number | undefined;
  step?: number | undefined;
  /** `mm` or `pt`, shown inside the control's trailing edge. */
  unit?: string | undefined;
  helpText?: string | undefined;
}

/**
 * A numeric template setting.
 *
 * A blank field leaves the model alone rather than reporting 0. Otherwise a
 * margin, band or type size would drop to nothing while it is being retyped,
 * and the preview would re-render a broken page.
 */
export function NumberField({ unit, onChange, step = 1, ...props }: NumberFieldProps) {
  return (
    <BaseNumberField
      {...props}
      nullable
      step={step}
      suffix={unit}
      onChange={(value) => {
        if (value !== null) onChange(value);
      }}
    />
  );
}
